
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_16554_14129)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14 1.5a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5v8.25l-.334.25H.25a.25.25 0 00-.25.25v.5c0 .137.112.25.25.25H2l1.466-1.1c.346-.26.768-.4 1.2-.4H8.25c.416 0 .75.334.75.75s-.334.75-.75.75H6.5c-.275 0-.5.225-.5.5s.225.5.5.5h4.631c.303 0 .597-.103.835-.29l1.925-1.538a.734.734 0 01.456-.163.64.64 0 01.431.163.664.664 0 01-.028 1.019l-3.15 2.521c-.237.191-.531.291-.834.291H.25a.25.25 0 00-.25.25v.5c0 .138.112.25.25.25h10.516c.53 0 1.043-.181 1.456-.512l3.153-2.522c.381-.306.61-.763.625-1.25a1.68 1.68 0 00-.553-1.294A1.646 1.646 0 0014 9.042V1.5zm-1 8.1V2h-3v4L8 4.998l-2 1V2H3v7.005A2.991 2.991 0 014.666 8.5h3.509c.881 0 1.681.619 1.806 1.49a1.74 1.74 0 01-.15 1.01h1.3c.078 0 .15-.025.21-.072L13 9.6zM9 4.381V2H7v2.381l1-.5 1 .5z","fill":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_16554_14129"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    